// extracted by mini-css-extract-plugin
export default {"vendorType":"vendorType__Yzg1Z","typeLocation":"typeLocation__YTJhO","dot":"dot__N2NlY"};